import { Anchor, Image } from "@mantine/core";
import MainContactContent from "../../pages/contact/MainContactContent";
import { RoutePaths } from "../../router";
import Icon from "/icon.svg";

export default function Footer() {
  const footerLinks = [
    {
      url: RoutePaths.Main,
      label: "Trang chủ",
    },
    {
      url: RoutePaths.About,
      label: "Về Popper24h",
    },
    {
      url: RoutePaths.PrivatePolicy,
      label: "Chính sách bảo mật",
    },
    // {
    //   url: RoutePaths.Product,
    //   label: "Sản phẩm",
    // },
    // {
    //   url: RoutePaths.Contact,
    //   label: "Liên hệ",
    // },
  ];

  return (
    <div className="footer p-4 bg-neutral-50 flex flex-col gap-6 text-neutral-600 mt-4 md:px-24">
      <div className="flex flex-col md:grid md:grid-cols-2 md:text-sm gap-4">
        <div className="footer-navigator flex flex-col gap-2">
          <div className="flex flex-row items-center justify-center">
            <Image src={Icon} w={256} />
          </div>

          <div>
            <h3 className="font-bold text-xl md:text-md my-4">Thông tin</h3>

            {/* Links */}
            <div className="flex flex-col gap-4">
              {footerLinks.map((link) => {
                return (
                  <Anchor
                    key={link.url}
                    href={link.url}
                    className="py-1 md:text-sm md:py-0"
                    c={"black"}
                  >
                    {link.label}
                  </Anchor>
                );
              })}
            </div>
          </div>
        </div>

        {/* Contacts */}
        <MainContactContent />
      </div>
    </div>
  );
}
